import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CustomerVM } from 'src/app/models/customer/customer.model';
import { AlertifyService } from 'src/app/services/Common/alertify.service';
import { CustomerService } from 'src/app/services/customer.service';

@Component({
  selector: 'app-customer-address-delete',
  templateUrl: './customer-address-delete.component.html',
  styleUrls: ['./customer-address-delete.component.css']
})
export class CustomerAddressDeleteComponent implements OnInit {

  Loader: boolean = false;
  customerModel: CustomerVM = new CustomerVM();

  constructor(private _customerService: CustomerService, private modalService: NgbModal, private alertify: AlertifyService) { }

  ngOnInit() {
    this._customerService.getAddressId.subscribe((id: string) => {
      this.customerModel.Id = +id;
    });
  }
  DeleteAddress() {
    this.Loader = true;
    this._customerService.DeleteAddressList(this.customerModel)
      .subscribe(response => {
        var responseBody = JSON.parse(response._body);
        if (responseBody.isSuccess) {
          this.alertify.success(responseBody.responseMessage);
          this.Loader = false;
          this.modalService.dismissAll();
        } else {
          this.Loader = false
        }
      })
  }
  onCancel() {
    this.modalService.dismissAll();
  }
}
